import TimePicker from 'rc-time-picker'
import React from 'react'
import { Image, Segment } from 'semantic-ui-react'

import add from '../../assets/images/add-small.png'
import remove from '../../assets/images/remove-small.png'
import { tr } from '../../helpers/languages'

const Slot = (props) => {
    return (
        <Segment className={`slot ${props.last ? 'last' : ''} ${props.erroneous ? 'error' : ''}`}>
            <TimePicker
                className='start'
                disabled={props.disabled}
                showSecond={false}
                format='HH:mm'
                value={props.start}
                onChange={(v) => { props.onChange('start', v) }}
            />
            <span className='to'>{tr('TO')}</span>
            <TimePicker
                className='end'
                disabled={props.disabled}
                showSecond={false}
                format='HH:mm'
                value={props.end}
                onChange={(v) => { props.onChange('end', v) }}
            />
            {
                !props.disabled && props.first && (
                    <Image
                        className='add-slot'
                        src={add}
                        onClick={(_e) => { props.onAdd() }}
                    />
                )
            }
            {
                !props.disabled && !props.first && (
                    <Image
                        className='remove-slot'
                        src={remove}
                        onClick={(_e) => { props.onRemove() }}
                    />
                )
            }
        </Segment>
    )
}

export default Slot



// WEBPACK FOOTER //
// ./src/components/availability/slot.js